import { format } from 'date-fns'

import { httpClient } from '@/services/http/httpClient'

import type { ForumCommentFile } from '../getIdeaForum'

export type IdeaCommentHttpResponse = {
  ideaComments: {
    id: string
    userId: string
    ideaId: string
    message: string
    tennantId: string
    createdAt: string
    user: {
      id: string
      email: string
      name: string
      image?: string
    }
    ideaCommentFiles: ForumCommentFile
  }[]
}

export type Comment = {
  id: string
  user: {
    id: string
    name: string
    image?: string
  }
  createdAt: string
  createdAtISO: string
  content: string
  file: ForumCommentFile | null
}

export type GetCommentResponse = {
  comments: Comment[]
}

export async function getComments(id: string): Promise<GetCommentResponse> {
  const { data } = await httpClient.get<IdeaCommentHttpResponse>(
    `/ideas/idea-comments/${id}?type[]=DEVELOPMENT&type[]=NORMAL`,
  )

  const comments = data.ideaComments.map((comment) => {
    const file = comment?.ideaCommentFiles

    const formattedComment: Comment = {
      id: comment.id,
      user: {
        id: comment.user.id,
        name: comment.user.name,
        image: comment.user.image,
      },
      createdAt: format(
        new Date(comment.createdAt.replace('Z', '')),
        'dd/MM/yyyy',
      ),
      createdAtISO: comment.createdAt,
      file: file
        ? {
            url: file.url,
            name: file.name,
            type: file.type,
          }
        : null,
      content: comment.message,
    }

    return formattedComment
  })

  return {
    comments,
  }
}
